import { ReactNode, Suspense } from "react";

function PageSkeleton() {
  return (
    <div className="animate-pulse px-4 sm:px-6 lg:px-8">
      <div className="h-16" />
      <div className="h-24 rounded-xl bg-light-secondary dark:bg-dark-secondary mb-4" />
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="h-40 rounded-xl bg-light-secondary dark:bg-dark-secondary" />
        <div className="h-40 rounded-xl bg-light-secondary dark:bg-dark-secondary" />
      </div>
    </div>
  );
}

interface PageSuspenseProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export function PageSuspense({ children, fallback }: PageSuspenseProps) {
  return (
    <Suspense fallback={fallback ?? <PageSkeleton />}>
      {children}
    </Suspense>
  );
}
